import { CenterFocusStrong, CropFree, ZoomIn, ZoomOut } from '@mui/icons-material'
import { theme } from '../../helpers/theme'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import MQTooltip from '../../components/core/tooltip/MQTooltip'
import React from 'react'
import { useSelector } from 'react-redux'
import { IState } from '../../store/reducers'
import { iframeDarkBlockSecondary, iframeLightColor, borderBlack, borderWhite } from '../../helpers/theme'

interface ZoomControlsProps {
  handleScaleZoom: (inOrOut: 'in' | 'out') => void
  handleResetZoom: () => void
  handleCenterOnNode?: () => void
}

export const ZoomControls = ({
  handleScaleZoom,
  handleResetZoom,
  handleCenterOnNode,
}: ZoomControlsProps) => {
  const i18next = require('i18next')
  const { theme: iframeTheme } = useSelector((state: IState) => state.iframe)
  return (
    <Box
      display={'flex'}
      border={1}
      borderRadius={1}
      flexDirection={'column'}
      m={1}
      position={'absolute'}
      right={0}
      zIndex={1}
      borderColor={iframeTheme === 'dark' ? borderBlack : borderWhite}
    >
      <MQTooltip title={i18next.t('lineage.zoom_in')} placement={'left'}>
        <IconButton size='small' onClick={() => handleScaleZoom('in')}>
          <ZoomIn sx={{ color: iframeTheme === 'dark' ? iframeLightColor : iframeDarkBlockSecondary }} />
        </IconButton>
      </MQTooltip>
      <MQTooltip title={i18next.t('lineage.zoom_out')} placement={'left'}>
        <IconButton size='small' onClick={() => handleScaleZoom('out')}>
          <ZoomOut sx={{ color: iframeTheme === 'dark' ? iframeLightColor : iframeDarkBlockSecondary }} />
        </IconButton>
      </MQTooltip>
      <MQTooltip title={i18next.t('lineage.reset_zoom')} placement={'left'}>
        <IconButton size={'small'} onClick={handleResetZoom}>
          <CropFree sx={{ color: iframeTheme === 'dark' ? iframeLightColor : iframeDarkBlockSecondary }} />
        </IconButton>
      </MQTooltip>
      {handleCenterOnNode && (
        <MQTooltip title={i18next.t('lineage.center_on_selected_node')} placement={'left'}>
          <IconButton size={'small'} onClick={handleCenterOnNode}>
            <CenterFocusStrong sx={{ color: iframeTheme === 'dark' ? iframeLightColor : iframeDarkBlockSecondary }} />
          </IconButton>
        </MQTooltip>
      )}
    </Box>
  )
}
